/* Representatives Admin Component */
export const representativeText = 'REPRESENTANTE'
export const studentsText = 'ESTUDIANTES'
export const idNumberText = 'Número de identificación'
export const memberCommitteeText = 'MIEMBRO DEL COMITÉ'
export const delegateText = 'DELEGADO'
export const adminTableNamesText = 'Nombres'
export const adminTableLastNamesText = 'Apellidos'
export const adminTableSavingText = 'Ahorro'
export const adminTableActiveText = 'Activo'
export const adminTableActionsText = 'Acciones'
export const updateTableButtonText = 'Actualizar Datos'
export const downloadButtonText = 'Descargar Excel'
export const loadFileSuccessMessageText = 'CARGA DE DOCUMENTOS EXITOSA'
export const errorResponseMessageText =
  'SUBIÓ UN ARCHIVO CON ERRORES, PULSE EL BOTÓN SI DESEA DESCARGAR LOS ERRORES'
export const wrongFormatMessageText = 'ARCHIVO CON FORMATO INCORRECTO'
export const fileExceedsMessageText = 'EL ARCHIVO EXCEDE EL PESO REQUERIDO'

/* Student Account Delete Popup */
export const deleteStudentAccountText = '¡INACTIVACIÓN CUENTA ESTUDIANTE!'
export const deleteStudentAccountContentText =
  'Al inactivar al estudiante, se eliminará automáticamente el ahorro programado y el acceso a la plataforma.'
export const deleteStudentAccountContentText4 = 'Para continuar la acción es necesario:'
export const deleteStudentAccountContentText1 =
  '1. Verificar que el documento tenga las firmas de al menos dos miembros del comité.'
export const deleteStudentAccountContentText2 = '2. Entregar el documento físico a la fiduciaria.'
export const deleteStudentAccountConfirmButtonText = 'CONFIRMAR INACTIVACIÓN'
export const confirmButtonText = 'CONFIRMAR'

/* Table representative list */
export const adminText = 'Administrar'

/* Change Delegate Role Popup */
export const changeRoleText = 'Cesar rol de delegado'
export const transferRoleText = 'Esta a punto de transferir su rol de delegado a otro usuario.'
export const thisActionCloseSessionText = 'Esta acción provocará el cierre de su sessión'
export const doYouSureToContinueText = 'Está seguro que desea continuar?'

/* Update Data Student/Representative page */
export const studentFormText = 'Estudiante'
export const representativeFormText = 'Representante'

export const backButtonText = 'REGRESAR'

export const saveChangesButtonText = 'GUARDAR CAMBIOS'

/* Update Data Student/Representative Popup */
export const titleUpdateDataPopupText = 'ACTUALIZACIÓN DE DATOS'
export const contentUpdateDataPopupText = 'Tus datos se actualizaron exitosamente. '
export const buttonUpdateDataPopupText = 'Continuar navegando'
export const studentNameText = 'Nombre del estudiante'
export const studentLastnameText = 'Apellidos del estudiante'
export const studentIDText = 'Número de identificación del estudiante'
export const studentPromotionText = 'Promoción'
export const representativeNameText = 'Nombre del representante'
export const representativeLastnameText = 'Apellidos del representante'
export const representativeIdText = 'Número de identificación del representante'
export const representativePhoneText = 'Teléfono del representante'
export const representativeEmailText = 'Correo electrónico del representante'
export const representativeDetailsText = 'CONSULTA DE DETALLES REPRESENTANTES '
